import I18n from '../../../config/i18n';
import CheckoutTime from '../../availabilityWidget/components/CheckoutTime';
import AlternativePrices from './AlternativePrices';
import MatchingPrice from './MatchingPrice';

import './Price.css';

export interface PriceInfo {
  price: number;
  arrival: moment.Moment | string;
  departure: moment.Moment | string;
  checkin: string;
  checkout: string;
}

interface PriceProps {
  loading: boolean;
  hasMatchingPrice: boolean;
  matchingPrice: PriceInfo | null;
  alternativePrices?: PriceInfo[];
  renderMatchingAndAlternatives: boolean;
}

export default function Price({
  hasMatchingPrice,
  matchingPrice,
  loading,
  alternativePrices,
  renderMatchingAndAlternatives,
}: PriceProps): JSX.Element {
  const validMatchingPrice = hasMatchingPrice && matchingPrice;
  const renderMatchingPrice = !!validMatchingPrice;
  const renderAlternativePrice =
    (!validMatchingPrice || renderMatchingAndAlternatives) &&
    !!alternativePrices &&
    alternativePrices.length > 0;

  if (!renderMatchingPrice && !renderAlternativePrice) {
    return (
      <div className="price alt-prices">
        <div>{I18n.t('price.not_available')}</div>
      </div>
    );
  }

  return (
    <div>
      {renderMatchingPrice ? (
        <div>
          <MatchingPrice priceInfo={matchingPrice} loading={loading} />{' '}
          <CheckoutTime checkin={matchingPrice.checkin} checkout={matchingPrice.checkout} />
        </div>
      ) : null}
      {renderAlternativePrice ? (
        <div className="price__alternatives">
          <AlternativePrices
            loading={loading}
            alternativePrices={alternativePrices}
            additionToMatchingPrice={renderMatchingPrice && renderAlternativePrice}
          />
        </div>
      ) : null}
    </div>
  );
}
const defaultProps: Pick<PriceProps, 'alternativePrices'> = {
  alternativePrices: undefined,
};

Price.defaultProps = defaultProps;
